<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Item {{ headers.class }}</em>
				<span class="int_type_no_border mgr_5"> <ItemClassSelect v-model="itemClass" :showName="false" :codeWidth="100" @set-item-class="setSearchClass" /> </span>
				<em v-if="profile.use_size_code == 'Y'" class="lt_text">Color </em>
				<span v-if="profile.use_size_code == 'Y'" class="int_type_no_border mgr_5">
					<CodeSelect className="tbl_select sm_int" :width="100" :codeWidth="100" :showDesc="false" codeType="COL" :codes="colors" v-model="color_code" />
				</span>

				<span class="int_type mgr_15">
					<select v-model="closed_yn" class="tbl_select sm_int">
						<option v-for="tag in this.$closedTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<span class="int_type mgr_15">
					<select v-model="active_yn" class="tbl_select sm_int">
						<option v-for="tag in this.$activeTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<span class="int_type">
					<input type="text" v-model="keyword" placeholder="Keyword or Barcode" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>
				<span class="int_type" style="width:60px;">
					<input type="text" v-model="rack" placeholder="Rack" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>
				<span class="int_type mgr_15" style="width:60px;">
					<input type="text" v-model="section" placeholder="Section" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>

				<em class="lt_text">On Hand</em>
				<span class="int_type">
					<select v-model="on_hand_condition" class="tbl_select sm_int">
						<option :value="null"></option>
						<option value="less_than">&lt;</option>
						<option value="equal">=</option>
						<option value="greater_than">&gt;</option>
					</select>
				</span>
				<span class="int_type mgr_15 " style="width:60px;">
					<currency-input type="text" class="al_right" :precision="0" v-model="on_hand_quantity" autocomplete="off" />
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_tbl">
				<div style="height: 630px; overflow-y: auto; overflow-x: hidden;">
					<table id="item_list" class="list_tbl tbl_pointer" v-columns-resizable>
						<thead>
							<tr>
								<th style="text-align:center;width:70px;">Item ID</th>
								<th style="text-align:center;width:150px;">Item Code</th>
								<th v-if="user.company_id != 'jc'" style="text-align:center;width:100px;">Color Code</th>
								<th v-if="user.company_id == 'he'" style="text-align:center;width:120px;">Color Name</th>
								<th v-if="profile.use_size_code == 'Y'" style="text-align:center;width:60px;">Size</th>
								<th style="text-align:center">Name</th>
								<th style="text-align:center;width:45px;">Pack</th>
								<th style="text-align:center;width:45px;">Unit</th>

								<th style="text-align:center;width:45px;">Loc.</th>
								<th style="text-align:center;width:45px;">Rack</th>
								<th style="text-align:center;width:45px;">Sec.</th>
								<th style="text-align:center;width:100px;">Barcode</th>

								<th style="text-align:center;width:65px;">On Hand</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="item in items" v-bind:key="item.item_id" v-bind:class="{ on: item.item_id == selectedItem.item_id }" @click="selectRow(item)">
								<td>{{ item.item_id }}</td>
								<td class="truncate">{{ item.item_code }}</td>
								<td v-if="user.company_id != 'jc'">{{ item.color_code }}</td>
								<td v-if="user.company_id == 'he'">{{ item.color_name }}</td>
								<td v-if="profile.use_size_code == 'Y'">{{ item.size_code }}</td>
								<td class="truncate">{{ item.name }}</td>
								<td style="text-align:right;">{{ item.packing }}</td>
								<td>{{ item.unit_code }}</td>

								<td>{{ item.location_name }}</td>
								<td>{{ item.rack }}</td>
								<td>{{ item.section }}</td>
								<td>{{ item.barcode }}</td>

								<td style="text-align:right;">{{ item.on_hand | commaSeparated }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div style="text-align:right;padding-top:5px;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

				<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

				<div class="view_bottom_bt">
					<span class="int_type_no_border mgr_15">
						<PageSizeSelect v-model="page_size" @input="search()" />
					</span>
					<a href="javascript:;" :class="selectedItem.item_id ? 'gray_bt' : 'disable_bt'" style="margin-right:15px" @click="inventoryHistory()">Inventory History</a>
				</div>
			</div>

			<div class="right_tbl">
				<h4 class="inner_h5">Inventory Detail</h4>
				<div style="height: 530px; overflow-y: auto; overflow-x: hidden;">
					<table id="item_list" class="list_tbl tbl_pointer" v-columns-resizable border="0">
						<thead>
							<tr>
								<th style="text-align:center;width:160px;">CRT Datetime</th>
								<th style="text-align:center;width:80px;">Shipment No</th>
								<th style="text-align:center;width:70px;">Exp Date</th>
								<th style="text-align:center;width:70px;">Init Qty</th>
								<th style="text-align:center;width:70px;">Cur Qty</th>
								<th style="text-align:center;width:70px;">Location</th>
								<th style="text-align:center;">{{ user.company_id == 'jc' ? 'LOT#' : 'BIN' }}</th>
								<th style="text-align:center;width:40px;">Del</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="(lot, index) in lots" v-bind:key="lot.lot_no">
								<td>{{ lot.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }}</td>
								<td>{{ lot.sh_dn }}</td>
								<td class="al_left"><CustomDatePicker v-model="lot.exp_date" /></td>
								<td><currency-input type="text" v-model="lot.initial_quantity" :precision="0" class="tbl_int sssm_int al_right" @focus="$event.target.select()" /></td>
								<td><currency-input type="text" v-model="lot.on_hand" :precision="0" class="tbl_int sssm_int al_right" @focus="$event.target.select()" /></td>
								<td>
									<select v-model="lot.location_code" class="tbl_select">
										<option v-for="location in locations" v-bind:value="location.code" v-bind:key="location.code">{{ location.name }}</option>
									</select>
									<!-- <CodeSelect className="tbl_select" :width="83" :codes="locations" :showDesc="false" v-model="lot.location_code" /> -->
								</td>
								<td><input type="text" v-model="lot.bin" class="tbl_int" @focus="$event.target.select()" /></td>
								<td>
									<template v-if="lot.lot_no && !lot.sh_no">
										<a href="javascript:void(0);" class="gray_bt2" @click="delLot(lot, index)">Del</a>
									</template>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="view_bottom_bt" style="padding-top:5px;">
					<a v-if="modifiable" href="javascript:;" class="gray_bt mgr_15" @click="addLot()">Add</a>
					<a v-if="modifiable" href="javascript:;" class="search_bt" @click="submit()">Save</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectItemList } from '@/api/item/master.js';
import { apiSelectLotList, apiSaveLots } from '@/api/item/inventory.js';
import Paging from '@/components/common/Paging';
import PageSizeSelect from '@/components/common/PageSizeSelect';
import CodeSelect from '@/components/common/CodeSelect';
import ItemClassSelect from '@/components/common/ItemClassSelect';

import CustomDatePicker from '@/components/common/CustomDatePicker.vue';

export default {
	data: function() {
		return {
			uri: null,
			//itemClasses: [],
			colors: [],
			sizes: [],
			units: [],
			locations: [],

			backUri: '/',
			paging_yn: 'Y',
			page_size: 0,
			page_no: 1,
			list_count: 0,

			itemClass: null,

			keyword: '',
			rack: '',
			section: '',
			color_code: null,
			closed_yn: 'N',
			active_yn: 'Y',
			on_hand_condition: null,
			on_hand_quantity: 0,

			items: [],
			selectedItem: {},

			item: {},
			lots: [],

			lot_nos_to_del: [],
		};
	},
	props: ['headers'],
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		profile: function() {
			return this.$session.get('profile');
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
	},
	components: {
		Paging,
		PageSizeSelect,
		CodeSelect,
		ItemClassSelect,
		CustomDatePicker,
	},
	methods: {
		setSearchClass(ic) {
			//console.log(itemClass);
			this.itemClass = ic.code;
			this.search();
		},

		addLot() {
			if (!this.selectedItem.item_id) return;

			this.lots.push({});
		},

		delLot(lot, index) {
			if (lot.sh_no > 0) {
				this.$toast.error('Inventory that has a shipment cannot be deleted.');
				return;
			}

			if (lot.lot_no > 0) this.lot_nos_to_del.push(lot.lot_no);
			this.lots.splice(index, 1);
		},

		inventoryHistory() {
			if (!this.selectedItem.item_id) return;

			let routeData = this.$router.resolve({ name: 'inventoryHistory', params: {}, query: { backUri: this.uri, item_id: this.selectedItem.item_id } });
			window.open(routeData.href, 'herp_inventory_history');
		},

		search() {
			this.page_no = 1;
			this.selectItems();
		},
		reset() {
			this.page_no = 1;
			this.active_yn = 'Y';
			this.keyword = '';
			this.color_code = null;
			this.rack = '';
			this.section = '';
			this.itemClass = null;

			this.search();
		},
		async selectItems(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;
			this.item = {};
			this.selectedItem = {};

			var param = {
				class_code: this.itemClass,
				color_code: this.color_code,
				keyword: this.keyword,
				rack: this.rack,
				section: this.section,

				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				closed_yn: this.closed_yn,
				active_yn: this.active_yn,

				on_hand_condition: this.on_hand_condition,
				on_hand_quantity: this.on_hand_quantity,
			};

			const { data } = await apiSelectItemList(param);
			this.items = data.itemList;

			this.list_count = data.list_count;

			if (this.items.length == 1) {
				this.selectRow(this.items[0]);
			}

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			inputSelectOnClick();
			var uri = '/item/inventory_adjust?dummy=1';
			if (this.itemClass) uri += '&class_code=' + this.itemClass;
			if (this.keyword) uri += '&keyword=' + this.keyword;
			if (this.page_no) uri += '&page_no=' + this.page_no;
			if (this.closed_yn) uri += '&closed_yn=' + this.closed_yn;
			if (this.active_yn) uri += '&active_yn=' + this.active_yn;

			this.uri = uri;
			window.history.pushState({}, null, uri);
		},
		async checkValidity() {
			return true;
		},
		async submit() {
			if (!this.selectedItem.item_id) return;

			const param = { item_id: this.selectedItem.item_id, lots: this.lots, lot_nos_to_del: this.lot_nos_to_del, adjust_reason: 'adjust' };
			//console.log(param);

			const { data } = await apiSaveLots(param);

			if (data.result) {
				this.$toast.success('Saved successfully');
				this.selectedItem.on_hand = data.on_hand;
			} else {
				this.$toast.error(data.msg);
			}
		},
		gotoPage(pageNo) {
			//console.log('going to page', pageNo);
			//this.page_no = pageNo;
			this.selectItems(pageNo);
		},
		async selectLotList() {
			const { data } = await apiSelectLotList({
				paging_yn: 'N',
				item_id: this.selectedItem.item_id,
			});

			//console.log(data);

			this.lots = data.lotList;
		},
		selectRow(item) {
			this.selectedItem = item;

			this.selectLotList();
		},
		async index() {
			const { data } = await apiIndex();

			//this.itemClasses = data.itemClassList;
			this.colors = data.colorList;
			this.sizes = data.sizeList;
			this.units = data.unitList;
			this.locations = data.locationList;
			//console.log(this.itemClasses);

			//this.setDlOptions(this.dlClassGroup, data.classGroupList);
		},
		async init() {
			await this.index();
			//if (this.$route.query.item_id) this.item_id = this.$route.query.item_id;
			if (this.$route.query.class_code) this.class_code = this.$route.query.class_code;
			if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
			if (this.$route.query.page_no) this.page_no = this.$route.query.page_no;
			if (this.$route.query.closed_yn) this.closed_yn = this.$route.query.closed_yn;
			if (this.$route.query.active_yn) this.active_yn = this.$route.query.active_yn;
			this.page_size = this.$store.getters['getDefaultPageSize'];

			await this.selectItems(this.$route.query.page_no);
		},
	},
	created() {
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;

		this.$store.commit('setSideIndex', 1);
		this.$store.commit('setSelectedMenu', 'nav_li_inventory_adjust');
		this.$store.commit('setSubTitle', 'Item -> Inventory Adjustment');

		this.init();
		// this.selectItems();
		inputSelectOnClick();
	},
	mounted() {
		this.$nextTick(function() {
			inputSelectOnClick();
			//makeTableResizable();
		});
	},
};
</script>

<style></style>
